export const SET_LOADING = 'SET_LOADING';

export const SET_PROJECT = 'SET_PROJECT';

export const UPDATE_PROJECT = 'UPDATE_PROJECT';

export const SET_TENANTS = 'SET_TENANTS';

export const DELETE_TENANT = 'DELETE_TENANT';

export const DISABLE_TENANT = 'DISABLE_TENANT';

export const ENABLE_TENANT = 'ENABLE_TENANT';

export const SET_TENANT_ID = 'SET_TENANT_ID';

export const SELECT_TENANT_ID = 'SELECT_TENANT_ID';

export const DESELECT_TENANT_ID = 'DESELECT_TENANT_ID';

export const SELECT_ALL_TENANT_IDS = 'SELECT_ALL_TENANT_IDS';

export const DESELECT_ALL_TENANT_IDS = 'DESELECT_ALL_TENANT_IDS';

export const TOGGLE_DELETE_APP_DIALOG = 'TOGGLE_DELETE_APP_DIALOG';

export const TOGGLE_DISABLE_APP_DIALOG = 'TOGGLE_DISABLE_APP_DIALOG';

export const TOGGLE_SYNC_ALL_TENANTS_DIALOG = 'TOGGLE_SYNC_ALL_TENANTS_DIALOG';

export const TOGGLE_SYNC_TENANT_DIALOG = 'TOGGLE_SYNC_TENANT_DIALOG';

export const UPDATE_ALL_TENANTS = 'UPDATE_ALL_TENANTS';

export const UPDATE_TENANT_BY_TENANT_ID = 'UPDATE_TENANT_BY_TENANT_ID';

export const SET_ERROR = 'SET_ERROR';
